// extracted by mini-css-extract-plugin
module.exports =  {"gwContactsTabContainer":"Contacts_gwContactsTabContainer__Dni+L","gwSectionTitle":"Contacts_gwSectionTitle__nINTM"};